// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4a77073a","457":"046bc8ad","732":"925ee14b","977":"c90382c6"}[chunkId] + ".chunk.js";
};